import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from './components/Layout/Layout';
import { VersionBadge } from './components/VersionBadge';
import DeprecationNotice from './components/DeprecationNotice/DeprecationNotice';

// The legacy TIL system is retired — Time in Lieu now lives in myHR. When true,
// the whole app is replaced by a retirement notice that redirects to myHR
// (new requests are also blocked server-side via RLS). Set false to restore.
const DEPRECATED = true;
const MYHR_URL = 'https://hr.scr.vic.edu.au';

// TIL System - Salesian College Sunbury
if (process.env.NODE_ENV === 'development') {
  console.log('🏫 TIL System - Development Mode');
}

// Salesian College color theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#00234B', // Salesian blue
    },
    secondary: {
      main: '#FFC233', // Salesian gold
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  if (process.env.NODE_ENV === 'development') {
    console.log('[APP] App component rendering');
  }
  if (DEPRECATED) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <DeprecationNotice redirectUrl={MYHR_URL} />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout />
      </Router>
      <VersionBadge />
    </ThemeProvider>
  );
}

export default App;